var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2C4.16421 2 4.5 2.33579 4.5 2.75V7H11.5V2.75C11.5 2.33579 11.8358 2 12.25 2C12.6642 2 13 2.33579 13 2.75V13.25C13 13.6642 12.6642 14 12.25 14C11.8358 14 11.5 13.6642 11.5 13.25V8.5H4.5V13.25C4.5 13.6642 4.16421 14 3.75 14C3.33579 14 3 13.6642 3 13.25V2.75C3 2.33579 3.33579 2 3.75 2Z",
    fill: "#586069"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.a03b9da62fa0cbcdd28d08a0dc454fee.svg";
export { ForwardRef as ReactComponent };